import { Injectable } from '@angular/core';
import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class ValidatorsService {
  public nombrePattern: string = '([a-zA-Z]+) ([a-zA-Z]+)';
  public documentPattern: string = '^[0-9]+';
  public quantityPattern: string = '[+-]?([0-9]*[.])?[0-9]+';
  public blanks: string = '/^\S*$/';
  public decimals: string = '/^\d+(\.\d{1,2})?$/';
  public positiveDecimal: ValidatorFn = Validators.pattern(/^\d+(\.\d+)?$/);
  //uppercase letters, lowercase letters, numbers, special character ($@$!%*?&+#)
  public passwordPattern: string =
    '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&+#])[A-Za-zd$@$!%*?&+#].{8,}';

  public emailValidator: ValidatorFn = (
    control: AbstractControl,
  ): ValidationErrors | null => {
    if (!control.value) return null;
    const emailError = Validators.email(control);
    if (emailError) return emailError;
    // RFC 5322 §3.4.1: internet-routable domains require at least one dot; Angular's Validators.email permits single-label domains (e.g. user@localhost)
    const domain: string = (control.value as string).split('@')[1] ?? '';
    return domain.includes('.') ? null : { email: true };
  };

  // Selected in the form is Colombia, and accepts values starting with digits otherwise.
  public documentValidatorByCountry(
    countryControl: AbstractControl,
  ): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;
      const pattern = this.isColombiaCountry(countryControl.value)
        ? /^[0-9]+$/
        : /^[a-zA-Z0-9][a-zA-Z0-9-]*$/;
      return pattern.test(control.value as string) ? null : { pattern: true };
    };
  }

  private isColombiaCountry(value: unknown): boolean {
    if (!value) return false;
    if (typeof value === 'string') return value === 'CO';
    if (typeof value === 'object') {
      const c = value as Record<string, unknown>;
      return (
        c['iso'] === 'COL' ||
        c['iso_alpha_2'] === 'CO' ||
        c['name'] === 'Colombia'
      );
    }
    return false;
  }

  equalFields(text1: string, text2: string) {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const pass1 = formGroup.get(text1)?.value;
      const pass2 = formGroup.get(text2)?.value;
      if (pass1 !== pass2) {
        formGroup.get(text2)?.setErrors({ unqual: true });
        return { unqual: true };
      } else {
        formGroup.get(text2)?.setErrors(null);
      }
      return null;
    };
  }
}
